import { render, staticRenderFns } from "./secondaryTable.vue?vue&type=template&id=4b669a50&scoped=true&"
import script from "./secondaryTable.vue?vue&type=script&lang=js&"
export * from "./secondaryTable.vue?vue&type=script&lang=js&"
import style0 from "./secondaryTable.vue?vue&type=style&index=0&id=4b669a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b669a50",
  null
  
)

export default component.exports